export default function LocationSection() {
  return (
    <section id="location" className="py-32 px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-20">
          <p className="text-sm text-amber-600 font-bold tracking-wider uppercase mb-4">
            VISIT US
          </p>
          <h2 
            className="text-5xl font-black mb-6"
            style={{ fontFamily: "'Noto Serif KR', serif" }}
          >
            오시는 길
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            신공 제작위원회 사무실로 직접 방문하실 수 있습니다
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div className="space-y-8">
            <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8">
              <h3 
                className="text-2xl font-bold mb-6"
                style={{ fontFamily: "'Noto Serif KR', serif" }}
              >
                신공 제작위원회
              </h3>
              
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-600 rounded-xl flex-shrink-0">
                    <i className="ri-map-pin-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">주소</p>
                    <p className="text-gray-900 font-medium">
                      서울특별시 강서구 개화동로25길 71-7<br />
                      104호
                    </p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-600 rounded-xl flex-shrink-0">
                    <i className="ri-phone-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">전화</p>
                    <p className="text-gray-900 font-medium">010-2638-1129</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-600 rounded-xl flex-shrink-0">
                    <i className="ri-mail-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">이메일</p>
                    <p className="text-gray-900 font-medium">kmiw6@naver.com</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 flex items-center justify-center bg-amber-600 rounded-xl flex-shrink-0">
                    <i className="ri-time-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500 mb-1">운영 시간</p>
                    <p className="text-gray-900 font-medium">
                      평일 10:00 - 18:00<br />
                      주말 및 공휴일 휴무
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-amber-50 rounded-2xl p-8 border-2 border-amber-200">
              <h4 className="text-lg font-bold mb-4 flex items-center gap-2">
                <i className="ri-subway-line text-amber-600 text-xl w-6 h-6 flex items-center justify-center"></i>
                대중교통 이용
              </h4>
              <div className="space-y-3 text-gray-700">
                <p>
                  <strong className="text-gray-900">지하철:</strong> 9호선 공항시장역 1번 출구
                </p>
              </div>
            </div>
          </div>

          <div className="lg:sticky lg:top-8">
            <div className="rounded-2xl overflow-hidden shadow-xl">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.0234567890123!2d126.80123456789012!3d37.56789012345678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x357b61234567890a%3A0x1234567890abcdef!2z7ISc7Jq47Yq567OE7IucIOqwleyEnOq1rCDqsJztmZTrj5nroZwyNeq4uCA3MS03!5e0!3m2!1sko!2skr!4v1234567890123!5m2!1sko!2skr"
                width="100%"
                height="600"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="신공 제작위원회 위치"
              ></iframe>
            </div>
            
            <div className="mt-6 flex gap-4">
              <a
                href="https://map.kakao.com/link/search/서울특별시 강서구 개화동로25길 71-7"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 px-6 py-4 bg-yellow-400 text-gray-900 font-bold rounded-xl hover:bg-yellow-500 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                <i className="ri-map-2-line mr-2"></i>
                카카오맵으로 보기
              </a>
              <a
                href="https://map.naver.com/v5/search/서울특별시 강서구 개화동로25길 71-7"
                target="_blank"
                rel="noopener noreferrer"
                className="flex-1 px-6 py-4 bg-green-500 text-white font-bold rounded-xl hover:bg-green-600 transition-colors text-center cursor-pointer whitespace-nowrap"
              >
                <i className="ri-navigation-line mr-2"></i>
                네이버지도로 보기
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
